import { useParams } from 'react-router-dom';

import { ChatConversation } from './ChatConversation';
import { NewChat } from './NewChat';

/** The portal's chat with Finlay: a new chat at `/hm/chat`, an existing one at `/hm/chat/:conversationId`. */
export function HMChat() {
  const { conversationId } = useParams<{ conversationId: string }>();

  return conversationId ? (
    <ChatConversation chatId={conversationId} key={conversationId} />
  ) : (
    <NewChat />
  );
}
